module.exports = __webpack_public_path__ + "static/media/privacyTerms.395f8b40.pdf";